import type { FC } from 'react';

import type { GenericSvgIconProps } from '../CustomIcon';

export const MinimizeArrowsIcon: FC<GenericSvgIconProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M21.0068 9.993C21.0068 10.5432 20.5564 10.9934 20.006 10.9934H13.9915C13.4411 10.9934 12.9907 10.5432 12.9907 9.993V3.99075C12.9907 3.44054 13.4411 2.99037 13.9915 2.99037C14.5419 2.99037 14.9922 3.44054 14.9922 3.99075V7.58209L20.2862 2.29011C20.4864 2.10004 20.7366 2 20.9967 2C21.2569 2 21.5071 2.09003 21.7073 2.29011C22.0976 2.68026 22.0976 3.31049 21.7073 3.70064L16.4133 8.99262H20.006C20.5564 8.99262 21.0068 9.44279 21.0068 9.993Z"
        fill="currentColor"
      />
      <path
        d="M8.99775 16.4154L3.70378 21.7074C3.31349 22.0975 2.68301 22.0975 2.29272 21.7074C1.90243 21.3172 1.90243 20.687 2.29272 20.2969L7.58669 15.0049H3.994C3.44358 15.0049 2.99325 14.5547 2.99325 14.0045C2.99325 13.4543 3.44358 13.0041 3.994 13.0041H9.9985C10.5489 13.0041 10.9992 13.4543 10.9992 14.0045V20.0068C10.9992 20.557 10.5489 21.0071 9.9985 21.0071C9.44809 21.0071 8.99775 20.557 8.99775 20.0068V16.4154Z"
        fill="currentColor"
      />
    </svg>
  );
};

MinimizeArrowsIcon.displayName = 'MinimizeArrowsIcon';
